import {
    SET_FILTERS
} from './index';

export function setFilters(filters) {
    return {
        type: SET_FILTERS,
        payload: filters
    }
}





// WEBPACK FOOTER //
// ./src/actions/actions-datagrid.js